import React from "react";

import ArrowLeft from "./arrowLeft";

export default function arrowDown({ color = "#d7d9dd", ...restProps }) {
  return (
    <ArrowLeft transform="rotate(-90)" color={color} {...restProps} />
  );
}
